import React from 'react'
import { activity_dates, LOCALE } from '../../../constants/activity-constants'

const LOCAL = process.env.LOCALE
const urlByLocal = {
  'es-CO': 'https://www.nosotrasonline.com.co/',
  'es-CL': 'https://www.nosotrasonline.cl/',
  'es-PE': 'https://www.nosotrasonline.com.pe/',
  'es-EC': 'https://www.nosotrasonline.com.ec/',
  'es-DO': 'https://www.nosotrasonline.com.do/',
  'es-PR': 'https://www.nosotrasonline.com.pr/',
  'es-BO': 'https://www.nosotrasonline.com.bo/',
}[LOCAL]

const country = {
  'es-CO': 'Colombia',
  'es-CL': 'Chile',
  'es-PE': 'Perú',
  'es-EC': 'Ecuador',
  'es-DO': 'República Dominicana',
  'es-PR': 'Puerto Rico',
  'es-BO': 'Bolivia',
}[LOCAL]

const linkjsx = urllink => (
  <a href={urllink} className="--link" target="_blank">
    {urllink}
  </a>
)

const link = linkjsx(urlByLocal)
const link_contactanos = linkjsx(urlByLocal + 'contactanos')
let default_terms = [
  <>
    <h5>PRIMERO: ACEPTACIÓN </h5>
    La participación en la Actividad promocional implica el expreso e íntegro
    conocimiento y aceptación de los presentes Términos y Condiciones. El
    participante que no esté de acuerdo con los Términos y Condiciones en los
    que se desarrollará la Actividad tiene el pleno derecho de no participar en
    la misma. Sin embargo, la participación en la Actividad demuestra plenamente
    la aceptación íntegra, total y sin condiciones de los siguientes Términos y
    Condiciones. Essity, se reserva el derecho a modificar parcial o totalmente
    los presentes Términos y Condiciones, sin necesidad de notificación previa a
    las participantes. En todo caso, Essity pondrá a disposición de las
    participantes las modificaciones a la Actividad en los mismos canales y
    cantidades que los Términos y Condiciones iniciales.
  </>,
  <>
    <h5>SEGUNDO: RESPONSABLE DE LA ACTIVIDAD</h5>
    Grupo Familia como responsable y organizador invita a participar en la
    Actividad La Tiendita Navideña, en adelante la “Actividad” de acuerdo con la
    información, condiciones, requisitos y limitaciones, que se detallan en el
    presente documento.
  </>,
  <>
    <h5>TERCERO: VIGENCIA </h5>La Actividad estará vigente a partir del{' '}
    {activity_dates[0]} hasta el {activity_dates[1]}. Durante todo el término de
    la Actividad , las participantes deberán cumplir con los requisitos
    establecidos en el numeral quinto y demás establecidos en el presente
    documento.{' '}
  </>,
  <>
    <h5>CUARTO: TERRITORIO</h5>
    La Actividad se llevará a cabo a través de sitio web
    {link} donde podrán encontrar toda la información y redes sociales donde se
    comunicará la Actividad en las ciudades de aplica para TODO {country}.
  </>,
  <>
    <h5>QUINTO: REQUISITOS PARA PARTICIPAR</h5>
    Los requisitos que deberán cumplir las participantes en la Actividad son los
    siguientes: Las participantes deben estar registradas en
    {link} Participar en la Actividad a través de la página web de {link} Las
    usuarias deben redimir 2 puntos por cada wallpaper, 2 puntos por cada
    sticker y 5 puntos por cada tarjeta personalizada que quieran descargar. Las
    usuarias deben cumplir con la mecánica de la Actividad. Las participantes
    deben residir en {country}. Las participantes declaran conocer y aceptar que
    la participación en la Actividad . Por tanto, las participantes se
    comprometen a cumplir dichos requisitos sin condicionamiento alguno y
    entienden que de no hacerlo no podrán concursar.{' '}
  </>,
  <>
    <h5>SEXTO: MECÁNICA DE LA ACTIVIDAD</h5>
    Todas las participantes de esta Actividad deben estar registradas en
    {link} Las usuarias deben redimir: 2 puntos por cada wallpaper. 2 puntos por
    cada sticker. 5 puntos por cada tarjeta personalizada. Los premios no son
    acumulables con otras promociones o actividades, no son intercambiables por
    dinero ni son canjeables por ningún otro concepto o producto identificado
    con la marca Nosotras ® o de Essity. La marca Nosotras tiene el derecho de
    anular o descalificar cualquier material que considere que no cumple con las
    reglas del concurso. Así mismo, procederá con el material que no tenga
    relación con la mecánica de la Actividad, que considere no apto o que atente
    contra los valores de la marca. Con el hecho de participar en la Actividad,
    , las ganadoras aceptan y autorizan que su nombre y sus imágenes aparezcan
    en las publicaciones y demás material de divulgación con fines promocionales
    que los organizadores deseen hacer durante el concurso o una vez este
    finalice, sin que ello implique la obligación de renumerarlas o
    compensarlas. El hecho de que la usuaria participe en la dinámica implica el
    conocimiento y la aceptación de las condiciones establecidas en reglamento,
    página web y correo electrónico. La Actividad estará al aire desde el{' '}
    {activity_dates[0]} hasta el {activity_dates[1]}. Concurso válido solo para
    usuarias que residen en Colombia. En caso de tener dudas, o si quieres
    recibir mayor información, comunícate con nosotras por nuestras redes
    sociales o a {link_contactanos}
  </>,
  <>
    <h5>SÉPTIMO: MÉTODO DE SELECCIÓN DEL GANADOR</h5>
    La Actividad tendrá un cover de puntos según el elemento descargable que la
    usuaria decida adquirir.{' '}
  </>,
  <>
    <h5>OCTAVO: DESCRIPCIÓN Y CONDICIONES DEL PREMIO</h5>
    La Actividad tendrá un ranking o top de jugadoras. Ganarán las 10 usuarias
    que más puntaje obtengan entre las fechas pactadas para la Actividad . Luego
    Familia analizará que las usuarias en el Top cumplan con todos los criterios
    de los Términos y Condiciones de la Actividad y las contactará para
    otorgarles su premio. El premio objeto de la Actividad no podrá ser
    modificado, ni será canjeable en efectivo. Grupo Familia se reserva el
    derecho de sustituir el o los premios por uno de similar valor y modificar
    los presentes Términos y Condiciones en cualquier momento, informando a las
    participantes.{' '}
  </>,
  <>
    <h5>NOVENO: ENTREGA DEL PREMIO</h5>
    Los ganadores deberán compartir sus datos (nombre completo, correo
    electrónico, cédula de ciudadanía y dirección) por el sitio web
    {link} Grupo Familia enviará el premio durante en un plazo máximo de 15 días
    hábiles lo verán reflejado en su cuenta.{' '}
  </>,
  <>
    <h5>DÉCIMO: GASTOS QUE DEBE ASUMIR EL CONSUMIDOR </h5>
    No hay gastos asociados a este premio
  </>,
  <>
    <h5> UNDÉCIMO: AUTORIZACIÓN TRATAMIENTO DE DATOS</h5>
    Grupo Familia informa que con el diligenciamiento de tus datos estás
    autorizando el tratamiento de los mismos. Nuestra política de privacidad
    está disponible en {link}. Usaremos tu nombre, número de cédula, teléfono
    celular/fijo, y correo electrónico para comunicarnos en caso de que seas el
    ganador de esta Actividad . Si aceptas darnos tu autorización para procesar
    tus datos, tendrás derecho a conocer, actualizar y rectificar tus datos
    personales; a solicitar prueba de esta autorización; a ser informado sobre
    el tratamiento que Productos Familia S.A. ha dado a tus datos personales; a
    presentar consultas o quejas, o a cancelar tu suscripción en cualquier
    momento, enviando un correo electrónico a [cumplimiento.gf@essity.com]{' '}
  </>,
  <>
    Con el hecho de participar en la Actividad , los ganadores aceptan y
    autorizan que su nombre y sus imágenes aparezcan en las publicaciones y
    demás material de divulgación con fines promocionales que los organizadores
    deseen hacer durante el concurso o una vez este finalice, sin que ello
    implique la obligación de remunerarlos o compensarlos.{' '}
  </>,
  <>
    Grupo Familia tiene el derecho de anular o descalificar cualquier material
    que considere que no cumple con las reglas del concurso. Asimismo, procederá
    con el material que no tenga relación con la mecánica de la Actividad, que
    considere no apto o atente contra los valores de la marca.
  </>,
  <>
    <b>
      En caso de tener dudas o si quieres recibir más información, comunícate a
      la línea de servicio y atención al cliente de la marca.
    </b>
  </>,
]

/***
 *  ARG TERMS
 */
if (LOCAL === 'es-AR') {
  default_terms = [
    <>
      <h5>PRIMERO: ACEPTACIÓN </h5>
      La participación en la Actividad promocional implica el expreso e íntegro
      conocimiento y aceptación de los presentes Términos y Condiciones. El
      participante que no esté de acuerdo con los Términos y Condiciones en los
      que se desarrollará la Actividad tiene el pleno derecho de no participar
      en la misma. Sin embargo, la participación en la Actividad demuestra
      plenamente la aceptación íntegra, total y sin condiciones de los
      siguientes Términos y Condiciones. Essity, se reserva el derecho a
      modificar parcial o totalmente los presentes Términos y Condiciones, sin
      necesidad de notificación previa a las participantes. En todo caso, Essity
      pondrá a disposición de las participantes las modificaciones a la
      Actividad en los mismos canales y cantidades que los Términos y
      Condiciones iniciales.
    </>,
    <>
      <h5>SEGUNDO: RESPONSABLE DE LA ACTIVIDAD </h5>
      Grupo Familia como responsable y organizador invita a participar en la
      Actividad Nosotras Magic Box, en adelante la “Actividad” de acuerdo con la
      información, condiciones, requisitos y limitaciones, que se detallan en el
      presente documento.
    </>,
    <>
      <h5>TERCERO: VIGENCIA</h5>
      La Actividad estará vigente a partir del xxx hasta el xxx. Durante todo el
      término de la Actividad , las participantes deberán cumplir con los
      requisitos establecidos en el numeral quinto y demás establecidos en el
      presente documento.
    </>,
    <>
      <h5>CUARTO: TERRITORIO</h5> La Actividad se llevará a cabo a través de
      sitio web https://www.nosotrasonline.com.ar/ donde podrán encontrar toda
      la información y redes sociales donde se comunicará la Actividad en las
      ciudades de aplica para TODO ARGENTINA.
    </>,
    <>
      <h5>QUINTO: REQUISITOS PARA PARTICIPAR </h5>
      Los requisitos que deberán cumplir las participantes en la Actividad son
      los siguientes: Las participantes deben estar registradas en
      https://www.nosotrasonline.com.ar/ Participar en la Actividad a través de
      la página web de https://www.nosotrasonline.com.ar/ Las usuarias deben
      canjear 10 puntos por cada wallpaper, 10 puntos por el paquete de stickers
      y 5 puntos por cada tarjeta personalizada que quieran descargar. Las
      usuarias deben cumplir con la mecánica de la Actividad. Las participantes
      deben residir en Argentina. Las participantes declaran conocer y aceptar
      que la participación en la Actividad . Por tanto, las participantes se
      comprometen a cumplir dichos requisitos sin condicionamiento alguno y
      entienden que de no hacerlo no podrán concursar.
    </>,
    <>
      <h5> SEXTO: MECÁNICA DE LA ACTIVIDAD </h5>
      Todas las participantes de esta Actividad deben estar registradas en
      https://www.nosotrasonline.com.ar/ Las usuarias deben canjear: 10 puntos
      por cada wallpaper. 10 puntos por el paquete de stickers. 5 puntos por
      cada tarjeta personalizada. Los premios no son acumulables con otras
      promociones o actividades, no son intercambiables por dinero ni son
      canjeables por ningún otro concepto o producto identificado con la marca
      Nosotras ® o de Essity. La marca Nosotras tiene el derecho de anular o
      descalificar cualquier material que considere que no cumple con las reglas
      del concurso. Así mismo, procederá con el material que no tenga relación
      con la mecánica de la Actividad, que considere no apto o que atente contra
      los valores de la marca. Con el hecho de participar en la Actividad, , las
      ganadoras aceptan y autorizan que su nombre y sus imágenes aparezcan en
      las publicaciones y demás material de divulgación con fines promocionales
      que los organizadores deseen hacer durante el concurso o una vez este
      finalice, sin que ello implique la obligación de remunerarlas o
      compensarlas. El hecho de que la usuaria participe en la dinámica implica
      el conocimiento y la aceptación de las condiciones establecidas en el
      reglamento, página web y correo electrónico. La Actividad estará al aire
      desde el xxxxx hasta el xxxxx de 2022. Concurso válido solo para usuarias
      que residen en Argentina. En caso de tener dudas, o si quieres recibir
      mayor información, comunícate con nosotras por nuestras redes sociales o a
      https://www.nosotrasonline.com.ar/contactanos/
    </>,
    <>
      <h5>SÉPTIMO: DESCRIPCIÓN Y CONDICIONES DE LOS DESCARGABLES</h5> Los
      descargables de la Actividad no podrán ser modificados, ni serán
      canjeables en efectivo. Grupo Familia se reserva el derecho de hacer
      cambios sobre el material descargable.
    </>,
    <>
      <h5> OCTAVO: GASTOS QUE DEBE ASUMIR EL CONSUMIDOR</h5> No hay gastos
      asociados a este premio
    </>,
    <>
      <h5>NOVENO: AUTORIZACIÓN TRATAMIENTO DE DATOS</h5> Grupo Familia informa
      que con el diligenciamiento de tus datos estás autorizando el tratamiento
      de los mismos. Nuestra política de privacidad está disponible en
      https://www.nosotrasonline.com.ar/ Usaremos tu nombre, número de cédula,
      teléfono celular/fijo, y correo electrónico para comunicarnos en caso de
      requerirse para la presente Actividad. Si aceptas darnos tu autorización
      para procesar tus datos, tendrás derecho a conocer, actualizar y
      rectificar tus datos personales; a solicitar prueba de esta autorización;
      a ser informado sobre el tratamiento que Productos Familia S.A. ha dado a
      tus datos personales; a presentar consultas o quejas, o a cancelar tu
      suscripción en cualquier momento, enviando un correo electrónico a
      [cumplimiento.gf@essity.com]]
    </>,
  ]
}

if (LOCALE === 'es-PY') {
  default_terms = [
    <>
      <h5>PRIMERO: ACEPTACIÓN</h5>
      La participación en la Actividad promocional implica el expreso e íntegro
      conocimiento y aceptación de los presentes Términos y Condiciones. El
      participante que no esté de acuerdo con los Términos y Condiciones en los
      que se desarrollará la Actividad tiene el pleno derecho de no participar
      en la misma. Sin embargo, la participación en la Actividad demuestra
      plenamente la aceptación íntegra, total y sin condiciones de los
      siguientes Términos y Condiciones. Essity, se reserva el derecho a
      modificar parcial o totalmente los presentes Términos y Condiciones, sin
      necesidad de notificación previa a las participantes. En todo caso, Essity
      pondrá a disposición de las participantes las modificaciones a la
      Actividad en los mismos canales y cantidades que los Términos y
      Condiciones iniciales.
    </>,
    <>
      <h5>SEGUNDO: RESPONSABLE DE LA ACTIVIDAD</h5>
      Grupo Familia como responsable y organizador invita a participar en la
      Actividad Nosotras Magic Box, en adelante la “Actividad” de acuerdo con la
      información, condiciones, requisitos y limitaciones, que se detallan en el
      presente documento.
    </>,
    <>
      <h5>TERCERO: VIGENCIA</h5>
      La Actividad estará vigente a partir del xxx hasta el xxx. Durante todo el
      término de la Actividad , las participantes deberán cumplir con los
      requisitos establecidos en el numeral quinto y demás establecidos en el
      presente documento.
    </>,
    <>
      <h5>CUARTO: TERRITORIO</h5>
      La Actividad se llevará a cabo a través de sitio web
      https://www.nosotrasonline.com.py/ donde podrán encontrar toda la
      información y redes sociales donde se comunicará la Actividad en las
      ciudades de aplica para TODO PARAGUAY.
    </>,
    <>
      <h5>QUINTO: REQUISITOS PARA PARTICIPAR</h5>
      Los requisitos que deberán cumplir las participantes en la Actividad son
      los siguientes: Las participantes deben estar registradas en
      https://www.nosotrasonline.com.py/ Participar en la Actividad a través de
      la página web de https://www.nosotrasonline.com.py/ Las usuarias deben
      canjear 10 puntos por cada wallpaper, 10 puntos por el paquete de stickers
      y 5 puntos por cada tarjeta personalizada que quieran descargar. Las
      usuarias deben cumplir con la mecánica de la Actividad. Las participantes
      deben residir en Paraguay. Las participantes declaran conocer y aceptar
      que la participación en la Actividad . Por tanto, las participantes se
      comprometen a cumplir dichos requisitos sin condicionamiento alguno y
      entienden que de no hacerlo no podrán concursar.
    </>,
    <>
      <h5>SEXTO: MECÁNICA DE LA ACTIVIDAD </h5>
      Todas las participantes de esta Actividad deben estar registradas en
      https://www.nosotrasonline.com.py/ Las usuarias deben canjear: 10 puntos
      por cada wallpaper. 10 puntos por el paquete de stickers. 5 puntos por
      cada tarjeta personalizada. Los premios no son acumulables con otras
      promociones o actividades, no son intercambiables por dinero ni son
      canjeables por ningún otro concepto o producto identificado con la marca
      Nosotras ® o de Essity. La marca Nosotras tiene el derecho de anular o
      descalificar cualquier material que considere que no cumple con las reglas
      del concurso. Así mismo, procederá con el material que no tenga relación
      con la mecánica de la Actividad, que considere no apto o que atente contra
      los valores de la marca. Con el hecho de participar en la Actividad, , las
      ganadoras aceptan y autorizan que su nombre y sus imágenes aparezcan en
      las publicaciones y demás material de divulgación con fines promocionales
      que los organizadores deseen hacer durante el concurso o una vez este
      finalice, sin que ello implique la obligación de remunerarlas o
      compensarlas. El hecho de que la usuaria participe en la dinámica implica
      el conocimiento y la aceptación de las condiciones establecidas en el
      reglamento, página web y correo electrónico. La Actividad estará al aire
      desde el xxxxx hasta el xxxxx de 2022. Concurso válido solo para usuarias
      que residen en Paraguay. En caso de tener dudas, o si quieres recibir
      mayor información, comunícate con nosotras por nuestras redes sociales o a
      https://www.nosotrasonline.com.py/contactanos/
    </>,
    <>
      <h5>SÉPTIMO: DESCRIPCIÓN Y CONDICIONES DE LOS DESCARGABLES</h5>
      Los descargables de la Actividad no podrán ser modificados, ni serán
      canjeables en efectivo. Grupo Familia se reserva el derecho de hacer
      cambios sobre el material descargable.
    </>,
    <>
      <h5>OCTAVO: GASTOS QUE DEBE ASUMIR EL CONSUMIDOR</h5>
      No hay gastos asociados a este premio
    </>,
    <>
      <h5>NOVENO: AUTORIZACIÓN TRATAMIENTO DE DATOS</h5>
      Grupo Familia informa que con el diligenciamiento de tus datos estás
      autorizando el tratamiento de los mismos. Nuestra política de privacidad
      está disponible en https://www.nosotrasonline.com.py/ Usaremos tu nombre,
      número de cédula, teléfono celular/fijo, y correo electrónico para
      comunicarnos en caso de requerirse para la presente Actividad. Si aceptas
      darnos tu autorización para procesar tus datos, tendrás derecho a conocer,
      actualizar y rectificar tus datos personales; a solicitar prueba de esta
      autorización; a ser informado sobre el tratamiento que Productos Familia
      S.A. ha dado a tus datos personales; a presentar consultas o quejas, o a
      cancelar tu suscripción en cualquier momento, enviando un correo
      electrónico a [cumplimiento.gf@essity.com]
    </>,
  ]
}

if (LOCALE === 'es-BO') {
  default_terms = [
    <>
      <h5>PRIMERO: ACEPTACIÓN </h5>
      La participación en la Actividad promocional implica el expreso e íntegro
      conocimiento y aceptación de los presentes Términos y Condiciones. El
      participante que no esté de acuerdo con los Términos y Condiciones en los
      que se desarrollará la Actividad tiene el pleno derecho de no participar
      en la misma. Sin embargo, la participación en la Actividad demuestra
      plenamente la aceptación íntegra, total y sin condiciones de los
      siguientes Términos y Condiciones. Essity, se reserva el derecho a
      modificar parcial o totalmente los presentes Términos y Condiciones, sin
      necesidad de notificación previa a las participantes. En todo caso, Essity
      pondrá a disposición de las participantes las modificaciones a la
      Actividad en los mismos canales y cantidades que los Términos y
      Condiciones iniciales.
    </>,
    <>
      <h5>SEGUNDO: RESPONSABLE DE LA ACTIVIDAD</h5>
      Grupo Familia como responsable y organizador invita a participar en la
      Actividad Nosotras Magic Box, en adelante la “Actividad” de acuerdo con la
      información, condiciones, requisitos y limitaciones, que se detallan en el
      presente documento.
    </>,
    <>
      <h5>TERCERO: VIGENCIA </h5>La Actividad estará vigente a partir del{' '}
      {activity_dates[0]} hasta el {activity_dates[1]}. Durante todo el término
      de la Actividad , las participantes deberán cumplir con los requisitos
      establecidos en el numeral quinto y demás establecidos en el presente
      documento.{' '}
    </>,
    <>
      <h5>CUARTO: TERRITORIO</h5>
      La Actividad se llevará a cabo a través de sitio web
      {link} donde podrán encontrar toda la información y redes sociales donde
      se comunicará la Actividad en las ciudades de aplica para TODO BOLIVIA.
    </>,
    <>
      <h5>QUINTO: REQUISITOS PARA PARTICIPAR</h5>
      Los requisitos que deberán cumplir las participantes en la Actividad son
      los siguientes: Las participantes deben estar registradas en
      {link} Participar en la Actividad a través de la página web de {link}. Las
      usuarias deben cumplir con la mecánica de la Actividad. Las participantes
      deben residir en Bolivia. Las participantes declaran conocer y aceptar que
      la participación en la Actividad . Por tanto, las participantes se
      comprometen a cumplir dichos requisitos sin condicionamiento alguno y
      entienden que de no hacerlo no podrán concursar.
    </>,
    <>
      <h5>SEXTO: MECÁNICA DE LA ACTIVIDAD</h5>
      Todas las participantes de esta Actividad deben estar registradas en
      {link} Las usuarias deben redimir: 2 puntos por cada wallpaper. 2 puntos
      por cada sticker. 5 puntos por cada tarjeta personalizada. Los premios no
      son acumulables con otras promociones o actividades, no son
      intercambiables por dinero ni son canjeables por ningún otro concepto o
      producto identificado con la marca Nosotras ® o de Essity. La marca
      Nosotras tiene el derecho de anular o descalificar cualquier material que
      considere que no cumple con las reglas del concurso. Así mismo, procederá
      con el material que no tenga relación con la mecánica de la Actividad, que
      considere no apto o que atente contra los valores de la marca. Con el
      hecho de participar en la Actividad, , las ganadoras aceptan y autorizan
      que su nombre y sus imágenes aparezcan en las publicaciones y demás
      material de divulgación con fines promocionales que los organizadores
      deseen hacer durante el concurso o una vez este finalice, sin que ello
      implique la obligación de renumerarlas o compensarlas. El hecho de que la
      usuaria participe en la dinámica implica el conocimiento y la aceptación
      de las condiciones establecidas en reglamento, página web y correo
      electrónico. La Actividad estará al aire desde el {activity_dates[0]}{' '}
      hasta el {activity_dates[1]}. Concurso válido solo para usuarias que
      residen en Bolivia. En caso de tener dudas, o si quieres recibir mayor
      información, comunícate con nosotras por nuestras redes sociales o a{' '}
      {link_contactanos}
    </>,
    <>
      <h5>SÉPTIMO: DESCRIPCIÓN Y CONDICIONES DE LOS DESCARGABLES</h5>
      Los descargables de la Actividad no podrán ser modificados, ni serán
      canjeables en efectivo. Grupo Familia se reserva el derecho de hacer
      cambios sobre el material descargable.
    </>,
    <>
      <h5>OCTAVO: GASTOS QUE DEBE ASUMIR EL CONSUMIDOR</h5>
      No hay gastos asociados a este premio
    </>,
    <>
      <h5> NOVENO: AUTORIZACIÓN TRATAMIENTO DE DATOS</h5>
      Grupo Familia informa que con el diligenciamiento de tus datos estás
      autorizando el tratamiento de los mismos. Nuestra política de privacidad
      está disponible en {link}. Usaremos tu nombre, número de cédula, teléfono
      celular/fijo, y correo electrónico para comunicarnos en caso de que seas
      el ganador de esta Actividad . Si aceptas darnos tu autorización para
      procesar tus datos, tendrás derecho a conocer, actualizar y rectificar tus
      datos personales; a solicitar prueba de esta autorización; a ser informado
      sobre el tratamiento que Productos Familia S.A. ha dado a tus datos
      personales; a presentar consultas o quejas, o a cancelar tu suscripción en
      cualquier momento, enviando un correo electrónico a
      [cumplimiento.gf@essity.com]{' '}
    </>,
  ]
}
const TERMS = default_terms

export default TERMS
